export type AltTextTranslations = Record<string, string>

export const SUPPORTED_LOCALES = ["es", "en", "de", "fr"] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export function getAltText(
	translations: string | null | undefined,
	fallback: string,
	locale: SupportedLocale = "es",
): string {
	if (!translations) return fallback

	let parsedTranslations: AltTextTranslations
	try {
		parsedTranslations = JSON.parse(translations) as AltTextTranslations
	} catch {
		return fallback
	}

	return parsedTranslations[locale] || parsedTranslations["es"] || fallback
}

export function generateAltTextTranslations(
	productName: string,
	brand: string,
	imageIndex: number,
): AltTextTranslations {
	const index = imageIndex + 1
	return {
		es: `${productName} - ${brand} - Imagen ${index}`,
		en: `${productName} - ${brand} - Image ${index}`,
		de: `${productName} - ${brand} - Bild ${index}`,
		fr: `${productName} - ${brand} - Image ${index}`,
	}
}

export function generateProductAltText(
	productName: string,
	brand: string,
): AltTextTranslations {
	return {
		es: `${productName} de ${brand}`,
		en: `${productName} by ${brand}`,
		de: `${productName} von ${brand}`,
		fr: `${productName} de ${brand}`,
	}
}
